// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"227":"fe4ee8228970a78d2138","540":"122b7d898c422dc85e70","547":"ebbd8be19725dbcba094","648":"a19b7a78c6d8ebf4ef2d","654":"318fd9e203e55e5a4728","844":"1a9f89c25d0a2aa7a81d","872":"08217aec308a3da2930b","961":"d1232e57ad9dce381c3a"}[chunkId] + ".js";
};